import { useGridRootProps as useCommunityGridRootProps } from '@mui/x-data-grid-pro';
export const useGridRootProps = useCommunityGridRootProps;